

































































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import StatsCurrencyMixin from "@/mixins/statsCurrencyMixin";

// Enums / Data
import {
  BrandConfigKeys,
  STATS_ALL_CURRENCY_CODE,
  ListDisplayMode
} from "@/data/constants";
import { TicketStatusCodes as TSC } from "@/data/enums/tickets";

// Types
import { IClient } from "@/models/clients";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import { ClientRoutes } from "@/data/enums/router";
import { Location as VueLocation } from "vue-router";

@Component({
  components: {
    "recent-invoices-list": () =>
      import("@/components/app/global/invoices/recentInvoicesList.vue"),
    "recent-tickets-list": () =>
      import("@/components/app/global/tickets/recentTicketsList.vue"),
    "invoices-total": () =>
      import("@/components/app/global/stats/invoicesTotal.vue"),
    "invoices-total-unpaid": () =>
      import("@/components/app/global/stats/invoicesTotalUnpaid.vue"),
    "total-orders": () =>
      import("@/components/app/global/stats/ordersTotal.vue"),
    "tickets-open": () =>
      import("@/components/app/global/stats/ticketsOpen.vue"),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      ),
    "upmind-usage-provider": () =>
      import("@/components/app/global/upmind/usageProvider.vue"),
    "upmind-usage-data-grid": () =>
      import("@/components/app/global/upmind/upmindUsageDataGrid.vue"),
    "cprods-by-group": () =>
      import("@/components/app/global/contractProducts/cProdsByGroup.vue"),
    "child-accounts-section": () =>
      import("@/components/app/global/client/childAccountsSection.vue")
  }
})
export default class ClientDashboardView extends Mixins(StatsCurrencyMixin) {
  public gridDisplayMode = ListDisplayMode.GRID;

  public currencyCode = STATS_ALL_CURRENCY_CODE;

  public readonly clientOrdersRoute: VueLocation = {
    name: ClientRoutes.ORDERS
  };

  public readonly clientInvoicesRoute: VueLocation = {
    name: ClientRoutes.INVOICES
  };

  public readonly clientInvoicesUnpaidRoute: VueLocation = {
    name: ClientRoutes.INVOICES_UNPAID
  };

  public readonly supportTicketsRoute: VueLocation = {
    name: ClientRoutes.SUPPORT_TICKETS
  };

  public readonly ticketsListProps = {
    limit: 4,
    statuses: [
      TSC.OPEN,
      TSC.IN_PROGESS,
      TSC.AWAITING_RESPONSE,
      TSC.CLIENT_REPLIED
    ]
  };

  public get clientId(): IClient["id"] {
    return this.$store.state.user.id;
  }

  public get isUpmindContext() {
    return this.$store.getters["isUpmindContext"];
  }

  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.DASHBOARD_OVERVIEW,
      objectId: this.clientId
    };
  }

  public get showSupportTickets() {
    return !(
      this.$store.getters["brand/config"][
        BrandConfigKeys.UI_CLIENT_APP_DISABLE_SUPPORT_SYSTEM
      ] ?? false
    );
  }

  public get showChildClients() {
    return this.$store.state.user.child_client_configs_count || 0 > 0;
  }
}
